import { render } from "./TodoForm.vue?vue&type=template&id=4f9fcf88"
import script from "./TodoForm.vue?vue&type=script&lang=js"
export * from "./TodoForm.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__